"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'nav.ai.none': 'Ninguna IA Seleccionada',
};
